<template>
  <div>
    <v-dialog
      v-model="isVisible"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      max-width="650"
      persistent
      scrollable
    >
      <v-card v-if="selectedOrder">
        <v-toolbar
          class="purple"
          flat
          height="80"
          max-height="80"
        >
          <v-avatar
            color="purple darken-3"
          >
            <v-icon
              v-if="selectedOrder.SourceTypeId < 100"
              color="white"
              size="28"
            >
              {{ getOrderSourceTypeById(selectedOrder.SourceTypeId)?.logo }}
            </v-icon>

            <img
              v-else
              :src="getOrderSourceTypeById(selectedOrder.SourceTypeId)?.logo"
              style="width: 32px; height: auto;"
            >
          </v-avatar>

          <v-toolbar-title class="pl-3 white--text">
            <div class="body-3">
              {{ $t('Order.OrdersAll.ListView.Button.Edit.Title') }}
            </div>
            <div>
              #{{ selectedOrder.OrderCode }}
            </div>
          </v-toolbar-title>

          <v-spacer />

          <v-btn
            dark
            icon
            @click="closeDialog"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-divider />

        <v-card-text class="pa-3">
          <v-container
            class="pa-1"
            fluid
          >
            <v-row dense>
              <v-col
                v-safe-html="confirmDialogEditOrderBody"
                class="text-body-1"
                cols="12"
              />
            </v-row>

            <v-row
              class="mt-4"
              dense
            >
              <v-col
                cols="12"
                sm="8"
              >
                <v-container
                  class="pa-0"
                  fluid
                >
                  <v-row no-gutters>
                    <v-col
                      cols="4"
                      sm="4"
                    >
                      <span :class="isDarkMode ? 'white--text' : 'black--text'">
                        {{ $t('Order.OrderDeleteDialog.Field.Name').toLocaleUpperCase($i18n.locale) }}
                      </span>
                    </v-col>
                    <v-col
                      class="grey--text text--darken-1"
                      cols="8"
                      sm="8"
                    >
                      {{ (parseInt(selectedOrder.CustomerId) !== 0 || selectedOrder.FullName !== 'null null') ? selectedOrder.FullName : $t('Customer.CustomerType.Visitor') }}
                    </v-col>

                    <v-col
                      cols="4"
                      sm="4"
                    >
                      <span :class="isDarkMode ? 'white--text' : 'black--text'">
                        {{ $t('Order.OrderDeleteDialog.Field.Telephone').toLocaleUpperCase($i18n.locale) }}
                      </span>
                    </v-col>
                    <v-col
                      class="grey--text text--darken-1"
                      cols="8"
                      sm="8"
                    >
                      {{ selectedOrder.Telephone }}
                    </v-col>

                    <v-col
                      cols="4"
                      sm="4"
                    >
                      <span :class="isDarkMode ? 'white--text' : 'black--text'">
                        {{ $t('Order.OrderDeleteDialog.Field.Time').toLocaleUpperCase($i18n.locale) }}
                      </span>
                    </v-col>
                    <v-col
                      class="grey--text text--darken-1"
                      cols="8"
                      sm="8"
                    >
                      {{ selectedOrder.TimeAdded }}
                    </v-col>

                    <v-col
                      cols="4"
                      sm="4"
                    >
                      <span :class="isDarkMode ? 'white--text' : 'black--text'">
                        {{ $t('Order.OrderDeleteDialog.Field.Total').toLocaleUpperCase($i18n.locale) }}
                      </span>
                    </v-col>
                    <v-col
                      class="grey--text text--darken-1"
                      cols="8"
                      sm="8"
                    >
                      <span
                        :class="isDarkMode ? 'white--text' : 'black--text'"
                        class="text-subtitle-1 font-weight-bold"
                      >{{ selectedOrder.Price | currency }}</span>
                    </v-col>
                  </v-row>
                </v-container>
              </v-col>

              <v-col
                cols="12"
                sm="4"
              >
                <v-container
                  class="pa-0"
                  fluid
                >
                  <v-row dense>
                    <v-col cols="12">
                      <order-status-chip
                        :order="selectedOrder"
                        dense
                        min-width="190"
                      />
                    </v-col>

                    <v-col cols="12">
                      <order-type-chip
                        :order="selectedOrder"
                        dense
                        label
                        min-width="190"
                      />
                    </v-col>

                    <v-col cols="12">
                      <order-payments-chip
                        :item="selectedOrder"
                        dense
                        min-width="190"
                      />
                    </v-col>
                  </v-row>
                </v-container>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-divider />

        <v-card-actions
          :class="$vuetify.breakpoint.xsOnly ? 'd-inline' : ''"
          class="pa-4"
        >
          <v-btn
            :block="$vuetify.breakpoint.xsOnly"
            class="elevation-0 v-btn--outline grey--text text--darken-1ma-0 my-1 ml-1"
            @click="closeDialog"
          >
            {{ $t('Common.Button.Cancel').toLocaleUpperCase($i18n.locale) }}
          </v-btn>

          <v-spacer />

          <v-menu
            :bottom="$vuetify.breakpoint.smAndUp"
            :top="$vuetify.breakpoint.xsOnly"
            left
            offset-y
            transition="slide-y-transition"
          >
            <template #activator="{on, attrs, value}">
              <v-btn
                :block="$vuetify.breakpoint.xsOnly"
                class="elevation-0 purple white--text caption ma-0 my-1 ml-1"
                v-bind="attrs"
                v-on="on"
              >
                <v-spacer />

                {{ $t('Common.Button.Edit') }}

                <v-spacer />

                <v-divider
                  class="ml-2"
                  vertical
                />

                <v-icon right>
                  {{ value ? 'mdi-menu-up' : 'mdi-menu-down' }}
                </v-icon>
              </v-btn>
            </template>


            <v-card>
              <v-card-text class="pa-2">
                <v-btn
                  v-if="!selectedOrder.DeletedAt"
                  block
                  class="elevation-0 darken-1 red--text caption ma-0 my-1"
                  @click="editDeleteOrder"
                >
                  {{ $t('Order.OrdersAll.ListView.Button.Edit.PopUp.Button.Delete').toLocaleUpperCase($i18n.locale) }}
                </v-btn>

                <v-btn
                  block
                  class="elevation-0 green darken-1 white--text caption ma-0 my-1"
                  @click="editCopyOrder"
                >
                  {{ $t('Order.OrdersAll.ListView.Button.Edit.PopUp.Button.Copy').toLocaleUpperCase($i18n.locale) }}
                </v-btn>

                <v-btn
                  v-if="canEditAdvanced"
                  block
                  class="elevation-0 info darken-1 white--text caption ma-0 my-1"
                  @click="editAdvancedOrder"
                >
                  {{ $t('Order.OrdersAll.ListView.Button.Edit.PopUp.Button.Edit').toLocaleUpperCase($i18n.locale) }}
                </v-btn>

                <v-btn
                  v-if="canEditOrderPayments"
                  block
                  class="elevation-0 indigo white--text caption ma-0 my-1"
                  @click="editOrderPayments"
                >
                  {{ $t('Order.OrdersAll.ListView.Button.Edit.PopUp.Button.Payment').toLocaleUpperCase($i18n.locale) }}
                </v-btn>
              </v-card-text>
            </v-card>
          </v-menu>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Auth from '@/mixins/auth'
import AppData from '@/mixins/appdata'
import OrderType from '@/mixins/orders/orderType'
import SourceType from '@/mixins/orders/sourceType'
import OrderStatusColor from '@/mixins/orders/orderStatus'
import OrderTypeTime from '@/mixins/orders/orderTypeTime'
import OrderTypeChip from '@/components/orders/common/OrderTypeChip'
import OrderStatusChip from '@/components/orders/common/OrderStatusChip'
import OrderPaymentsChip from '@/components/orders/common/OrderPaymentsChip'
import OrderReceipts from '@/mixins/orders/orderReceipts'
import OrderTransactions from '@/mixins/orders/orderTransactions'
import FiscalDocTypeEnum from '@/api/Enums/FiscalDocTypeEnum'
import SourceTypeEnum from '@/api/Enums/SourceTypeEnum.js'
import OrderStatusEnum from '@/api/Enums/OrderStatusEnum.js'

export default {
  name      : 'ConfirmOrderEditDialog',
  components: {
    OrderTypeChip,
    OrderStatusChip,
    OrderPaymentsChip
  },
  mixins: [AppData, Auth, OrderStatusColor, OrderType, OrderReceipts, OrderTransactions, SourceType, OrderTypeTime],
  props : {
    visible: {
      type   : Boolean,
      default: false
    },
    selectedOrder: {
      type   : [Object, Array],
      default: undefined
    }
  },
  data() {
    return {}
  },
  computed: {
    OrderStatusEnum() {
      return OrderStatusEnum
    },
    SourceTypeEnum() {
      return SourceTypeEnum
    },
    FiscalDocTypeEnum() {
      return FiscalDocTypeEnum
    },

    canEditAdvanced() {
      return !this.selectedOrderHasFiscalDocument && !this.selectedOrderIsRefundable && ![OrderStatusEnum.Canceled].includes(this.selectedOrder?.StatusId)
    },

    confirmDialogEditOrderBody() {
      return this.$t('Order.OrdersAll.ListView.Button.Edit.PopUp.Body')
    },

    selectedOrderIsRefundable() {
      return this.orderIsRefundable(this.selectedOrder)
    },

    selectedOrderRefundableAmount() {
      return this.orderRefundableAmount(this.selectedOrder)
    },

    selectedOrderHasFiscalDocument() {
      return this.orderHasFiscalDocument(this.selectedOrder)
    },

    canEditOrderPayments() {
      if (
        this.$route.name !== 'OrdersToday'
          || SourceTypeEnum.ONLINE_SOURCES.includes(parseInt(this.selectedOrder.SourceTypeId))
          || SourceTypeEnum.TABLE === parseInt(this.selectedOrder.SourceTypeId)
          || this.selectedOrder.StatusId === OrderStatusEnum.Canceled
          || (this.selectedOrder.DeletedAt && this.selectedOrder.StatusId === OrderStatusEnum.Canceled)
          || this.orderHasFiscalDocument(this.selectedOrder)
      ) {
        return false
      }

      return true
    },

    isVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  methods: {
    closeDialog() {
      this.isVisible = false
    },

    editDeleteOrder() {
      this.$emit('order-edit-delete', this.selectedOrder)
      this.closeDialog()
    },

    editCopyOrder() {
      this.$emit('order-edit-copy', this.selectedOrder)
      this.closeDialog()
    },

    editAdvancedOrder() {
      this.$emit('order-edit', this.selectedOrder)
      this.closeDialog()
    },

    editOrderPayments() {
      this.$emit('order-edit-payments', this.selectedOrder)
      this.closeDialog()
    }
  }
}
</script>

